import styles from './style.postcss';

import React from 'react';
import NormalTd from '../NormalTd';
import { Button } from 'omni-common-ui';
import PropTypes from 'prop-types';

const ButtonTd = (props) => <NormalTd>
  <div className={styles.ButtonTd_content}>
    <Button onClick={() => props.onButtonClick()}>
      {props.text}
    </Button>
  </div>
</NormalTd>;

ButtonTd.propTypes = {
  text: PropTypes.string,
  onButtonClick: PropTypes.func,
};

export default ButtonTd;



// WEBPACK FOOTER //
// ./components/TableView/Tds/ButtonTd/index.jsx